import {debounce, fetchData, formatedPrice} from "../../utils/common";
import {AddCartTypes} from "../../utils/consts";
import {changeAmountCount} from "../cart";

export const setPrice = (
  price,
  discount,
  totalPriceElement,
  discountContainerElement,
  discountElement,
) => {
  const parentTotalPriceElement = totalPriceElement.closest(`.cart__definition`);
  totalPriceElement.textContent = formatedPrice(price);

  if (!discount) {
    parentTotalPriceElement.classList.remove(`cart__definition--red`);
    discountContainerElement.classList.add(`hide`);
  } else {
    parentTotalPriceElement.classList.add(`cart__definition--red`);
    discountElement.textContent = formatedPrice(discount);
    discountContainerElement.classList.remove(`hide`);
  }
};

const changeCount = ({cart}) => {
  const countsElements = cart.querySelectorAll(`.js-count`);
  const totalPriceElement = cart.querySelector(`.js-total`);
  const discountElement = cart.querySelector(`.js-discount`);
  const discountContainerElement = cart.querySelector(`.js-discount-box`);
  const URL = `/basket/count`;

  countsElements.forEach((count) => {
    const state = {
      current: {
        count: count.count.value,
      },
      id: count.dataset.id,
      maxCount: count.dataset.maxAmount,
    };

    const changeCount = debounce(async () => {
      const {price, discount} = await fetchData(URL, state);

      setPrice(price, discount, totalPriceElement, discountContainerElement, discountElement);
    }, 300);

    count.addEventListener(`click`, async (evt) => {
      evt.preventDefault();

      if (evt.target.classList.contains(`js-count-plus`)) {
        if (state.maxCount && count.count.value === state.maxCount) {
          console.log(`Количество не может быть больше ${state.maxCount}`);
        } else {
          count.count.value++;

          changeAmountCount(count.count.value - state.current.count, AddCartTypes.PLUS);

          state.current.count = count.count.value;

          changeCount();
        }
      } else if (evt.target.classList.contains(`js-count-minus`)) {
        if (count.count.value === `1`) {
          console.log(`Количество не может быть меньше 1`);
        } else {
          count.count.value--;

          changeAmountCount(state.current.count - count.count.value, AddCartTypes.MINUS);

          state.current.count = count.count.value;

          changeCount();
        }
      }
    });
  });
};

export default changeCount;
